<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Investors Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/investors/accounts'"
            >Accounts</router-link
          >
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="
              '/' +
              authUser.userable_type +
              '/investors/account/' +
              accountCode +
              '/' +
              accountID
            "
            >{{ accountCode }}</router-link
          >
        </li>
      </ol>
    </div>
    <spinner v-if="searchingAccount" />

    <div
      v-else
      style="
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 60px;
      "
    >
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            min-height: 75px;
            border-radius: 50px;
            display: flex;
            align-items: center;
            flex-direction: row !important;
          "
        >
          <div style="padding-left: 50px; font-size: 18px" class="col-6">
            {{ accountCode }}
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin-bottom: 15px !important;
            border-top-right-radius: 30px;
            border-top-left-radius: 30px;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleAccountDetails()"
              class="col-6"
            >
              Account Details
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showAccountDetails ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="showAccountDetails ? 'display: flex' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-8">
              <div class="col-12 accountInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Code</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeAccount.code }}
                </label>
              </div>
              <div class="col-12 accountInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Net Balance</label
                >
                <label style="line-height: normal" class="col-9">
                  {{
                    fixNumberView(activeAccount.current_balance) +
                    " " +
                    activeAccount.currency.code
                  }}
                </label>
              </div>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            margin-bottom: 15px !important;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleAccountInvestor()"
              class="col-6"
            >
              Investor Details
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showAccountInvestor ? 'fa fa-arrow-up' : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="showAccountInvestor ? 'display: flex' : 'display: none'"
            style="min-height: 100px"
          >
            <div class="col-8">
              <div class="col-12 accountInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Investor Code</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeAccount.investor.code }}
                </label>
              </div>
              <div class="col-12 accountInfoClass">
                <label
                  class="col-3"
                  style="padding: 0; font-size: 13px; font-weight: bold"
                  >Investor Name</label
                >
                <label style="line-height: normal" class="col-9">
                  {{ activeAccount.investor_details.name }}
                </label>
              </div>
            </div>
          </div>
        </md-card>
      </div>
      <div class="col-10" style="margin-bottom: 25px">
        <md-card
          class="md-card-stats"
          style="
            display: flex;
            justify-content: center;
            margin: 0;
            border-bottom-right-radius: 30px;
            border-bottom-left-radius: 30px;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              flex-direction: row !important;
              min-height: 75px;
            "
          >
            <div
              style="
                padding-left: 50px;
                font-size: 18px;
                display: flex;
                align-items: center;
                cursor: pointer;
              "
              @click="toggleAccountTransactions()"
              class="col-6"
            >
              Transactions
              <i
                style="font-size: 10px; padding-left: 20px"
                :class="
                  showAccountTransactions
                    ? 'fa fa-arrow-up'
                    : 'fa fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            :style="
              showAccountTransactions ? 'display: block' : 'display: none'
            "
            style="min-height: 100px"
          >
            <spinner v-if="searchingAccount" />

            <vue-good-table
              v-else
              :columns="transactionColumns"
              :rows="activeAccount.transactions"
              max-height="450px"
              style="padding: 20px"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'code'">
                  <router-link
                    style="color: #00a5e3 !important"
                    :to="
                      '/' +
                      authUser.userable_type +
                      '/investors/transaction/' +
                      props.row.code +
                      '/update/' +
                      props.row.id
                    "
                  >
                    {{ props.formattedRow[props.column.field] }}</router-link
                  >
                </span>
                <span v-else-if="props.column.label == 'Fees'">
                  {{ fixNumberView(props.row.fees) }}
                </span>
                <span v-else-if="props.column.label == 'Amount'">
                  {{ fixNumberView(props.row.amount) }}
                </span>
                <span v-else-if="props.column.label == 'Final Amount (USD)'">
                  {{ getUSDAmount(props.row) }}
                </span>
              </template></vue-good-table
            >
            <!-- <div class="col-12" style="padding-bottom: 25px">
              <table style="width: 100%">
                <thead>
                  <tr style="text-align: center">
                    <th>#</th>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Type</th>
                    <th>Category</th>
                    <th>Amount</th>
                    <th>Currency</th>
                    <th>Exchange Rate</th>
                    <th>Fees</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    style="text-align: center"
                    v-for="(transaction, key) in activeAccount.transactions"
                    :key="key"
                  >
                    <td>{{ key + 1 }}</td>
                    <td>{{ transaction.code }}</td>
                    <td>
                      {{ transaction.description }}
                    </td>
                    <td>
                      {{
                        transactionTypes.find((type) => {
                          return type.id == transaction.type;
                        }).name
                      }}
                    </td>
                    <td>
                      {{ transaction.category.name }}
                    </td>
                    <td>
                      {{ fixNumberView(transaction.amount) }}
                    </td>
                    <td>
                      {{ transaction.currency.code }}
                    </td>
                    <td>
                      {{ transaction.exchange_rate }}
                    </td>
                    <td>
                      {{ transaction.fees }}
                    </td>
                    <td>
                      {{ transaction.date }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div> -->
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
import Spinner from "vue-simple-spinner";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import InvestorAccountsFilter from "../../filters/InvestorAccountsFilter";
import moment from "moment";

export default {
  name: "account",
  data() {
    return {
      showAccountTransactions: false,
      showAccountDetails: false,
      showAccountInvestor: false,
      accountID: null,
      accountCode: null,
      transactionColumns: [
        {
          label: "Transaction ID",
          field: "code",
        },
        {
          label: "Date",
          field: "date",
        },
        {
          label: "Investor ID",
          field: "owner_code",
        },
        {
          label: "Type",
          field: this.transactionType,
        },
        {
          label: "Category",
          field: this.categoryType,
        },
        {
          label: "Fees	",
          field: "fees",
        },
        {
          label: "Amount",
          field: "amount",
        },
        {
          label: "Currency",
          field: "currency.code",
        },
        {
          label: "Exchange Rate	",
          field: "exchange_rate",
        },

        // {
        //   label: "Final Amount (USD)",
        //   field: this.calculateUSDAmount,
        // },
      ],
    };
  },
  created: function () {
    this.accountID = this.$route.params.accountId;
    this.accountCode = this.$route.params.accountCode;
    var accountsFilter = InvestorAccountsFilter();
    accountsFilter.ids = [this.accountID];
    accountsFilter.with = ["investor", "transactions"];
    this.$store.dispatch("searchInvestorAccounts", {
      filter: accountsFilter,
      resultMode: "default",
    });
  },
  components: {
    Spinner,
  },
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      activeAccount: (state) =>
        state.accountsStore.investorAccountSearch.investorAccounts[0],
      searchingAccount: (state) =>
        state.accountsStore.investorAccountSearch.searchingInvestorAccounts,
    }),
    moment() {
      return moment;
    },
  },
  methods: {
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    transactionType(transaction) {
      return (
        transaction.type.charAt(0).toUpperCase() + transaction.type.slice(1)
      );
    },
    categoryType(transaction) {
      return (
        transaction.category.name.charAt(0).toUpperCase() +
        transaction.category.name.slice(1)
      );
    },
    calculateUSDAmount(transaction) {
      return transaction.amount * transaction.exchange_rate;
    },
    getUSDAmount(transaction) {
      var amount = this.calculateUSDAmount(transaction);
      return this.fixNumberView(amount);
    },
    toggleAccountTransactions() {
      this.showAccountTransactions = !this.showAccountTransactions;
    },
    toggleAccountDetails() {
      this.showAccountDetails = !this.showAccountDetails;
    },
    toggleAccountInvestor() {
      this.showAccountInvestor = !this.showAccountInvestor;
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes === 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    dateDifference(date2, date1) {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;

      // Discard the time and time-zone information.
      const utc1 = Date.UTC(
        date1.getFullYear(),
        date1.getMonth(),
        date1.getDate()
      );
      const utc2 = Date.UTC(
        date2.getFullYear(),
        date2.getMonth(),
        date2.getDate()
      );

      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    },
    deleteAccount() {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this account?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("deleteAccount", this.activeAccount.id);
        }
      });
    },
  },
  watch: {
    deleteAccountStatus() {
      if (this.deleteAccountStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Account has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.$router.push("/" + this.authUser.userable_type + "/accounts");
        });
      } else if (this.deleteAccountStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Account delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>
<style>
.accountInfoClass {
  padding-left: 75px;
  display: flex;
  align-items: start;
}

.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
}

.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
  background: none;
}

.vgt-inner-wrap {
  box-shadow: none !important;
}
.vgt-left-align {
  text-align: center;
}
.vgt-right-align {
  text-align: center;
}
.vgt-table.bordered td,
.vgt-table.bordered th {
  background: #fff;
}

table.vgt-table thead th {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: auto;
  scrollbar-color: #dbd5dc #ffffff;
}


/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: #dbd5dc;
  border-radius: 10px;
  border: 3px solid #ffffff;
}

</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/investorAccount.vue